import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fleetApi } from '../../api/fleet';
import { refusalMessage } from '../../api/errors';
import { rememberFleetRole } from '../../lib/fleetRole';

/**
 * The rider's delivery company on their profile (InGo ADR 0032): an owner is
 * taken to Fleet; a fleet's rider sees whose fleet it is and may leave it
 * (Rio, F2: from their profile), staying a rider; anyone else may start one.
 * A question that could not be asked shows nothing rather than an error.
 */
export default function RiderFleetSection({ fleet = fleetApi }) {
  const [view, setView] = useState(undefined);
  const [said, setSaid] = useState('');
  const [problem, setProblem] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let cancelled = false;

    fleet.me('today').then(
      (answer) => {
        rememberFleetRole(answer?.role ?? null);
        if (!cancelled) setView(answer);
      },
      () => {
        if (!cancelled) setView(null);
      },
    );

    return () => {
      cancelled = true;
    };
  }, [fleet]);

  if (!view) return null;

  const leave = async () => {
    if (!window.confirm(`Leave ${view.fleet.name}? You stay a rider, on your own.`)) return;
    setProblem('');
    setBusy(true);
    try {
      setSaid(await fleet.leave());
      rememberFleetRole(null);
      setView({ role: null, fleet: null });
    } catch (error) {
      setProblem(refusalMessage(error));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="dpr-section" aria-labelledby="dpr-fleet-h">
      <h2 id="dpr-fleet-h" className="dpr-secH">
        Delivery company
      </h2>
      <div className="dpr-secB dprRegCard">
        {view.role === 'owner' ? (
          <p className="dprRegVal" style={{ margin: 0 }}>
            You own {view.fleet.name}. <Link to="/driver/fleet">Open Fleet</Link>
          </p>
        ) : null}
        {view.role === 'rider' ? (
          <>
            <p className="dprRegVal" style={{ margin: 0 }}>
              You ride for {view.fleet.name}, owned by {view.owner.name}.
            </p>
            <button type="button" className="dpr-docView" onClick={leave} disabled={busy} style={{ marginTop: '0.5rem', background: 'none', border: 0, padding: 0 }}>
              {busy ? 'Leaving…' : 'Leave fleet'}
            </button>
          </>
        ) : null}
        {view.role === null ? (
          <p className="dprRegVal" style={{ margin: 0 }}>
            {said || 'You ride on your own.'} <Link to="/driver/fleet">Run a delivery company</Link>
          </p>
        ) : null}
        {problem ? (
          <p className="dpr-docMuted" role="alert" style={{ margin: '0.5rem 0 0' }}>
            {problem}
          </p>
        ) : null}
      </div>
    </section>
  );
}
